import {
  CameraIcon,
  SparklesIcon,
  PaletteIcon,
  SofaIcon,
  ScanIcon,
  WandIcon,
  SmartphoneIcon,
  CloudUploadIcon,
  ImageIcon,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface InteriorFeature {
  title: string
  desc: string
  icon: LucideIcon
  color: string
  bg: string
}

export const interiorFeatures: InteriorFeature[] = [
  { title: 'Odfotíte izbu', desc: 'Stačí jedna fotka. AI rozpozná rozmery, nábytok, svetlo aj štýl.', icon: CameraIcon, color: 'text-blue-600', bg: 'bg-blue-50' },
  { title: 'AI navrhne dizajn', desc: 'Gemini vytvorí návrhy v rôznych štýloch — od minimalizmu po luxus.', icon: SparklesIcon, color: 'text-purple-600', bg: 'bg-purple-50' },
  { title: 'Prispôsobíte farby', desc: 'Meníte steny, podlahy aj doplnky. AI drží harmóniu priestoru.', icon: PaletteIcon, color: 'text-amber-600', bg: 'bg-amber-50' },
  { title: 'Virtuálny nábytok', desc: 'Reálne produkty z katalógov vo vašej izbe ešte pred kúpou.', icon: SofaIcon, color: 'text-emerald-600', bg: 'bg-emerald-50' },
  { title: '3D vizualizácia', desc: 'Prejdite sa novým interiérom ešte pred realizáciou.', icon: ScanIcon, color: 'text-rose-600', bg: 'bg-rose-50' },
  { title: 'Rozpočet a nákup', desc: 'AI odhadne náklady a prepojí vás s dodávateľmi.', icon: WandIcon, color: 'text-indigo-600', bg: 'bg-indigo-50' },
]

export const interiorStyles = [
  { name: 'Minimalizmus', image: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=400&h=300&fit=crop&crop=center' },
  { name: 'Škandinávsky', image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=300&fit=crop&crop=center' },
  { name: 'Industriálny', image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=400&h=300&fit=crop&crop=center' },
  { name: 'Luxusný', image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=400&h=300&fit=crop&crop=center' },
]

export interface InteriorStep {
  title: string
  desc: string
  icon: LucideIcon
  iconColor: string
}

export const interiorSteps: InteriorStep[] = [
  { title: 'Odfoť svoj priestor', desc: 'Urob fotku miestnosti, ktorú chceš prerobiť — prázdnej aj zariadenej.', icon: SmartphoneIcon, iconColor: 'text-apple-blue' },
  { title: 'Nahraj do aplikácie', desc: 'Vyber typ miestnosti, štýl, farebnú paletu a rozpočet.', icon: CloudUploadIcon, iconColor: 'text-purple-600' },
  { title: 'Vygeneruj fotografiu', desc: 'AI za pár sekúnd vytvorí fotorealistický návrh nového interiéru.', icon: ImageIcon, iconColor: 'text-emerald-600' },
]
